/**
 * Copyright (C) 2019 Egylis,
 * Siège social, 83 bis rue de l'Abbé Groult, 75015 Paris - France.
 * All Rights Reserved.
 *
 * E-mail : info@egylis.com
 *
 * This software is the confidential and proprietary information
 * of Egylis. ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only
 * in accordance with the terms of the license agreement you
 * entered into with Egylis.
 *
 * Created by calvez on 20/03/19.
 *
 * Version : Generator 2.0.9
 */


import {Injectable} from '@angular/core';
import {StatusEnum} from '../entity';
import Dexie from 'dexie';
import {environment} from '../../environments/environment';

/**
 * Config Service
 */
@Injectable()
export class ConfigService {
    /**
     * Dexie Name
     */
    private static DEXIE_NAME: string = 'config';
    /**
     * Dexie Database
     */
    private dexieDb: Dexie;
    /**
     * Is started
     */
    private readonly _isStarted: boolean = false;

    /**
     * Constructor
     */
    constructor() {
        this.dexieDb = new Dexie(environment.name + '_' + ConfigService.DEXIE_NAME + '_' + environment.mode);
        this.dexieDb.version(1).stores({
            config: 'key'
        });
        this._isStarted = true;
    }

    /**
     * Return a promise who resolve when it's ready to start.
     * @return {Promise<StatusEnum>}
     */
    public isReadyToStart(): Promise<StatusEnum> {
        // console.log('=========== ConfigService isReadyToStart');
        return new Promise(
            (resolve) => {
                this.isStartedTimeout(resolve);
            });
    }

    /**
     * is Started with a timeout
     * @param promiseResolve
     */
    private isStartedTimeout(promiseResolve: (r: StatusEnum) => void): void {
        // console.log('-- ConfigService isStartedTimeout');
        if (this._isStarted) {
            // console.log('-- ConfigService isStartedTimeout -- OK');
            promiseResolve(StatusEnum.OK);
        } else {
            // console.log('-- ConfigService isStartedTimeout -- TimeOut');
            setTimeout(this.isStartedTimeout.bind(this, promiseResolve), 100);
        }
    }

    /**
     * Save a config
     * @param keyVal key
     * @param config config to save
     */
    public saveConfig(keyVal: string, config: {}): Promise<{}> {
        return this.dexieDb.table('config').put({
            key  : keyVal,
            value: config
        });
    }

    /**
     * Save a config
     * @param keyVal key
     */
    public getConfig(keyVal: string): Promise<{}> {
        return new Promise(
            (resolve, reject) => {
                this.dexieDb.table('config').get({key: keyVal})
                    .then(
                        (res) => {
                            if (res != null && res.value != null) {
                                resolve(res.value);
                            } else {
                                resolve(null);
                            }
                        },
                        () => {
                            reject();
                        }
                    );
            });
    }

}
